import { ReactElement } from 'react';
import { IconNames } from 'pages/NewOverview/types';
import { colors } from '~/styles/colors';
import { HealthVariant } from './types';
import { t } from 'i18next';
import { UnitCard } from '~/pages/NewOverview/components/UnitCard';

interface UnitCardProps {
  value?: number;
  variant: HealthVariant;
  onClickDetails?: () => void;
  canSeeDetails?: boolean;
}

interface VariantConfig {
  cardColor: string;
  iconColor: string;
  icon: IconNames;
  description: string;
}

const variantConfigs: Record<HealthVariant, VariantConfig> = {
  alert: {
    cardColor: colors.bg['warn-light'],
    iconColor: colors.state.warning.base,
    description: t('unidadesEmAlerta'),
    icon: 'WarnCircle',
  },
  critical: {
    cardColor: colors.bg['danger-light-0'],
    iconColor: colors.state.danger.base,
    description: t('unidadesEmAlertaCritico'),
    icon: 'XCircle1Icon',
  },
  healthy: {
    cardColor: colors.bg['success-light'],
    iconColor: colors.state.success.base,
    description: t('unidadesSaudaveis'),
    icon: 'CheckVerified1Icon',
  },
  inoperative: {
    cardColor: colors.bg['weak-100'],
    iconColor: colors.bg['soft-400'],
    description: t('unidadesOffline'),
    icon: 'SlashCircle1Icon',
  },
};

export function HealthUnitCard({
  variant,
  value,
  onClickDetails,
  canSeeDetails = true,
}: Readonly<UnitCardProps>): ReactElement {
  const config = variantConfigs[variant];
  const size = variant === 'alert' || variant === 'inoperative' ? 16 : 22;

  return (
    <UnitCard
      cardColor={config.cardColor}
      description={config.description}
      icon={{
        color: config.iconColor,
        name: config.icon,
        size,
      }}
      value={value}
      onClickDetails={canSeeDetails ? onClickDetails : undefined}
      disabledReasonKey={!canSeeDetails ? 'semUnidadesNesseStatus' : undefined}
    />
  );
}
